import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';

import { type DatasetPagination } from '@blaze-shared/datasets-domain';
import { type RuntimeContext } from '@blaze-shared/elements-domain';
import { IntelliSenseService } from '@blaze-shared/intellisense-feature';
import { type GetWorkflowNode } from '@blaze-shared/workflow-domain';

import { DatasetRowsQueryService } from './dataset-rows-query.service';

export interface DatasetGetInfo {
  data: any;
  pagination?: DatasetPagination;
}

/** Reads the rows a `Get` node's query matches. */
@Injectable({ providedIn: 'root' })
export class DatasetGetActionService {
  private readonly datasetRowsQueryService = inject(DatasetRowsQueryService);
  private readonly iss = inject(IntelliSenseService);

  datasetGet(
    node: GetWorkflowNode,
    nodeInput: any,
    ctx: RuntimeContext,
    workflowId?: string,
    workflowExecutionId?: string,
  ): Observable<DatasetGetInfo> {
    const context = this.iss.updateRuntimeContext(ctx, nodeInput);
    return this.datasetRowsQueryService.getDatasetRows({
      condition: node.condition || '',
      context,
      datasetId: node.datasetId || '',
      maxResults: node?.maxResults ? this.iss.eval(node.maxResults, context) : undefined,
      queryConditions: node.queryConditions,
      queryLogicalOp: node.queryLogicalOp,
      queryNode: node.query,
      sort: node.sort,
      subDataset: node.subDataset || '',
      workflowExecutionId,
      workflowId,
    });
  }
}
